import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useNavLinksContext } from '../../contexts/NavLinksContext';
import { useAppContext } from '../../contexts/Storage';
import { ListPageTemplate } from '../../components/Templates';
import { useStockValuation } from '../../components/Accounts';

const StockValuationPage: React.FC = () => {
  const { setNavLinks } = useNavLinksContext();
  const { selectedRecord } = useAppContext();
  const navigate = useNavigate();

  const {
    listItems,
    isLoading,
    hasRequiredParams,
    stocks,
  } = useStockValuation();

  // Set navigation links
  useEffect(() => {
    setNavLinks({
      links: [
        { to: '/dashboard', label: 'Dashboard' },
        { to: '/records', label: 'Records' },
        ...(selectedRecord
          ? [{ to: '/records/accounts/stock-valuation', label: selectedRecord.record_name || 'Stock Valuation' }]
          : []),
      ],
    });
  }, [setNavLinks, selectedRecord]);

  const handleItemClick = (item: { id: number | string; name?: string }) => {
    const stock = stocks.find((s) => s.id === item.id);
    if (stock) {
      navigate(`/records/accounts/stock-valuation/${stock.id}`, {
        state: { entityName: stock.transaction_entity_name },
      });
    }
  };

  // Show message if no record is selected
  if (!selectedRecord) {
    return (
      <div className="h-shink-from-navbar h-fill-from-navbar pl-2 bg-bg_grey_light text-dark overflow-y-scroll">
        <div className="bg-light rounded-lg p-8 text-center">
          <p className="text-grey_dark mb-4">Please select a record to view stock valuation.</p>
          <Link
            to="/records"
            className="text-primary hover:text-primary_dark underline"
          >
            Go to Records
          </Link>
        </div>
      </div>
    );
  }

  return (
    <ListPageTemplate
      title="Stock Valuation"
      description="Manage stock inventory valuation"
      items={listItems}
      loading={isLoading}
      showDateRange={false}
      onItemClick={handleItemClick}
      emptyMessage={
        !hasRequiredParams
          ? 'Please select a record to view stock valuation.'
          : 'No stock valuation items found for this record.'
      }
    />
  );
};

export default StockValuationPage;
